import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';

const PhdPageContext = ({ title, description, action }) => (
  <Alert
    type="info"
    showIcon
    title={title}
    description={description}
    action={action}
    style={{ marginBottom: 16 }}
  />
);

PhdPageContext.propTypes = {
  action: PropTypes.node,
  description: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
};

export default PhdPageContext;
